import { NotifyHelper } from "../../../helpers/toast";
import { eToaNhaActionsObj } from "../../action-types/category/IToaNhaActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const toaNhaActions = {
  ...generateActions(eToaNhaActionsObj, "TOA_NHA"),
  ...generateActionForKey(eToaNhaActionsObj, "TOA_NHA", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(
    eToaNhaActionsObj,
    "TOA_NHA",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(eToaNhaActionsObj, "TOA_NHA", "SAVE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eToaNhaActionsObj, "TOA_NHA", "DELETE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
